var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeBannerGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 695,
    height: 776,
    viewBox: "0 0 695 776",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_452_394)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 236.5,
    cy: 386.5,
    rx: 449.5,
    ry: 429.5,
    fill: "#72D8F7"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_452_394)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 769.969,
    cy: 397.059,
    rx: 333.617,
    ry: 455,
    transform: "rotate(-30 769.969 397.059)",
    fill: "#5C5AD6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_452_394",
    x: -613,
    y: -443,
    width: 1699,
    height: 1659,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 200,
    result: "effect1_foregroundBlur_452_394"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_452_394",
    x: 2.21509,
    y: -430.946,
    width: 1535.51,
    height: 1656.01,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 200,
    result: "effect1_foregroundBlur_452_394"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeBannerGradient);
export default __webpack_public_path__ + "static/media/home-banner-gradient.f2d8e09c560e2f00cc6eee6deda19253.svg";
export { ForwardRef as ReactComponent };